import axios from "axios";
import {environmentConfig} from "@/config";

export default class DepService {
    static async validateMyBundleEntry(productId, rawQueryString) {
        try {
            return await axios.post(`${environmentConfig.depService}/my-bundle/validate-entry`, {
                    productId,
                    rawQueryString
                }
            )
        } catch (e) {
            return {authError: true};
        }
    }
}
